import React from 'react';
import { Crown, Users } from 'lucide-react';

interface CollaborationRoleBadgeProps {
  role: 'owner' | 'collaborator';
  size?: 'small' | 'medium' | 'large';
  showIcon?: boolean;
}

export const CollaborationRoleBadge: React.FC<CollaborationRoleBadgeProps> = ({ 
  role, 
  size = 'medium', 
  showIcon = true 
}) => {
  const isOwner = role === 'owner';
  
  // 樣式配置
  const sizeClasses = {
    small: 'px-2 py-1 text-xs',
    medium: 'px-3 py-1.5 text-sm',
    large: 'px-4 py-2 text-base'
  };

  const iconSizes = {
    small: 'h-3 w-3',
    medium: 'h-4 w-4',
    large: 'h-5 w-5'
  };

  const baseClasses = `
    inline-flex items-center gap-1.5 rounded-full font-medium
    transition-all duration-200 border-2
    ${sizeClasses[size]}
  `;

  const ownerClasses = `
    ${baseClasses}
    bg-gradient-to-r from-yellow-50 to-yellow-100
    border-yellow-300
    text-yellow-800
    shadow-sm
    hover:shadow-md
  `;

  const collaboratorClasses = `
    ${baseClasses}
    bg-gradient-to-r from-wedding-pink/10 to-wedding-pink/20
    border-wedding-pink/40
    text-wedding-pink
    shadow-sm
    hover:shadow-md
  `;

  const Icon = isOwner ? Crown : Users;
  const label = isOwner ? '擁有者' : '協作者';

  return (
    <span className={isOwner ? ownerClasses : collaboratorClasses}>
      {showIcon && (
        <Icon className={`${iconSizes[size]} ${isOwner ? 'text-yellow-600' : 'text-wedding-pink'}`} />
      )}
      <span className="font-semibold">{label}</span>
    </span>
  );
};

export default CollaborationRoleBadge;